import React, { Component, Fragment } from 'react';
import {
  Container,
  Row, Col, Input, Label, Button, Form, FormGroup
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faCircle } from '@fortawesome/free-solid-svg-icons'
import { faCircle as faCircleOutline } from '@fortawesome/free-regular-svg-icons'

class AdminPermissions extends Component {

  standardRow = (permission) => {
    return (
      <Row className="adminRow pointer" onClick={() => this.props.onEdit(permission.ID)}>
        <Col className="text-left col-md-4">
          <FontAwesomeIcon icon={(permission['Active']) ? faCircle : faCircleOutline} className={"mr-3 " + ((permission['Active']) ? 'iconActive' : 'iconInactive')} />
          {permission['Permission']}
        </Col>
        <Col className="text-left col-md-3">{permission['Description']}</Col>
        <Col className="text-left col-md-3">{permission['api']}</Col>
        <Col className="text-left col-md-2">{permission['method']}</Col>
        {/* <Col className="text-right col-md-2">
          <Button className="mx-1" color="primary" onClick={() => this.props.onEdit(permission.ID)}><FontAwesomeIcon icon={faEdit} /></Button>
        </Col> */}
      </Row>
    )
  }

  editRow = (permission) => {
    return (
      <Row className="editRow adminRow">
        <Col md={8} className="text-left">
          <Form inline>
            <FormGroup className="pr-2">
              <Input
                placeholder="Permission"
                type={"edit-permission" + permission.ID}
                id="permission"
                name="permission"
                value={this.props.editPermission.permission + ''}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                placeholder="Description"
                type={"edit-description" + permission.ID}
                id="permission-description"
                name="description"
                value={this.props.editPermission.description + ''}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                placeholder="API"
                type={"edit-api" + permission.ID}
                id="permission-api"
                name="api"
                value={this.props.editPermission.api + ''}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                placeholder="Method"
                type={"edit-method" + permission.ID}
                id="permission-method"
                name="method"
                value={this.props.editPermission.method + ''}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                type="checkbox"
                id={"edit-active" + permission.ID}
                name="active"
                checked={this.props.editPermission.active}
                onChange={e => this.props.onChange(e, 'edit')} />
              <Label for={"edit-active" + permission.ID}>
                Active
                     </Label>
            </FormGroup>
          </Form>
        </Col>
        <Col className="text-right col-md-4">
          <Button className="mx-1" color="success" onClick={this.props.handleEdit} title="Edit Permission">
            <FontAwesomeIcon icon={faCheck} />
          </Button>
          {/* <Button className="mx-3" color="danger" onClick={() => this.props.onDelete(permission.ID)} edit="Delete Permission">
            <FontAwesomeIcon icon={faTrashAlt} />
          </Button> */}
          <Button className="mx-1" color="secondary" onClick={this.props.handleCancel} title="Cancel">
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        </Col>
        <Col className="text-right col-md-6 p-3">
          Assigned Roles
          </Col>
        <Col className="text-left col-md-6 p-3">
          {this.props.roles.map(role => (
            <Label key={role.ID} for={"role_" + role.ID}>
              <Input
                type="checkbox"
                name="roles"
                id={"role_" + role.ID + "_" + permission.ID}
                checked={[...this.props.roles].filter(o => o.Permissions.findIndex(j => j === permission.ID) > -1).map(i => i.ID).findIndex(u => u === role.ID) > -1}
                onChange={e => this.props.onChange(e, 'edit')}
              />
              {role['Role']}
            </Label>
          ))}
        </Col>
      </Row>
    )
  }

  addRow = () => {
    return (
      <Row className="py-4 text-left align-items-bottom ">
        <Col>
          <Form inline>
            <FormGroup className="pr-2">
              Add New Permission
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                placeholder="Permission"
                type="text"
                id="permission"
                name="permission"
                value={this.props.newPermission.permission + ''}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                placeholder="Description"
                type="text"
                id="permission-add-description"
                name="description"
                value={this.props.newPermission.description + ''}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                placeholder="API"
                type="text"
                id="permission-add-api"
                name="api"
                value={this.props.newPermission.api + ''}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                placeholder="Method"
                type="text"
                id="permission-add-method"
                name="method"
                value={this.props.newPermission.method + ''}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                type="checkbox"
                id={"permission-active"}
                name="active"
                checked={this.props.newPermission.active}
                onChange={e => this.props.onChange(e)} />
              <Label for={"permission-active"}>
                Active
            </Label>
            </FormGroup>
          </Form>
        </Col>
        <Col className="text-right col-md-3">
          <Button
            disabled={this.props.newPermission.permission === ''}
            color="primary"
            onClick={this.props.handleAdd}
          >Add Permission</Button>
        </Col>
      </Row>
    )
  }

  render() {
    return (
      <Container className="adminContainer" fluid>
        {this.props.permissions.map(permission => (
          <Fragment key={permission.ID}>{this.props.editPermission.id === permission.ID ? this.editRow(permission) : this.standardRow(permission)}</Fragment>
        ))}
        {this.addRow()}
      </Container>
    );

  }
}

export default AdminPermissions;